export const INITIAL_SEARCH = {
  page: 1,
  order_id: '',
  internal_order: '',
  action_like: '',
  order_by: 'id',
  sort_method: 'desc',
}
